import './lib/env'
import './lib/amplify'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { App } from './App'
import { initAnalytics } from './lib/analytics'
import { initErrorReporting } from './lib/errorReporting'
import './styles/globals.css'

// O3: initialize PostHog + Sentry once at app entry. Both no-op when their
// VITE_* keys are unset (local dev + CI), so this is safe to call unconditionally.
initAnalytics()
initErrorReporting()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
